import {BehaviorSubject, Observable} from 'rxjs';
import {Injectable} from '@angular/core';

export declare type HintType = '' | 'pwa-install';

@Injectable({
  providedIn: 'root'
})
export class HintService {

  private hint$ = new BehaviorSubject<HintType>('');

  // ********************************************************************************************************
  // BROADCAST DATA
  // ********************************************************************************************************

  newHint(newHint: HintType) {
    this.hint$.next(newHint);
  }

  onNewHint(): Observable<HintType> {
    return this.hint$.asObservable();
  }

  getHint(): HintType {
    return this.hint$.getValue();
  }

}
